import axios from 'axios';
import {url} from '../../../utils/urls';

const withCredentials = true;

export const getSSOconfig = siteUUID => {
   return axios.get(`${url.eua.url}/pub-portal/v1/sso-config/${siteUUID}`, {withCredentials: true});}



export const updateSSOConfig = (configUUID, requestData) =>{
    return axios.put(`${url.eua.url}/pub-portal/v1/sso-config/${configUUID}`, requestData, { withCredentials });}


// Profile Config
export const getProfileConfig = siteUUID =>{
   return axios.get(`${url.eua.url}/pub-portal/v1/profile-config/${siteUUID}`, {withCredentials });}

export const updateProfileConfig = ({configUUID, requestData}) =>{
   return axios.put(`${url.eua.url}/pub-portal/v1/profile-config/${configUUID}`, requestData, {withCredentials });}